import { Controller } from "@hotwired/stimulus"

// Number field whose value is saved in localStorage and applied as a URL
// query param. On a visit without the param, the stored value is re-applied
// automatically, so the filter survives reloads and new sessions.
export default class extends Controller {
  static targets = ["input"]
  static values = { param: String, storageKey: String }

  connect() {
    const current = new URL(window.location).searchParams.get(this.paramValue)
    const stored = localStorage.getItem(this.storageKeyValue)

    if (current !== null) {
      localStorage.setItem(this.storageKeyValue, current)
    } else if (stored !== null && parseFloat(stored) > 0) {
      this.navigate(stored)
    }
  }

  apply() {
    const value = this.inputTarget.value || "0"
    localStorage.setItem(this.storageKeyValue, value)
    this.navigate(value)
  }

  adjust(event) {
    const current = parseFloat(this.inputTarget.value) || 0
    const next = Math.min(100, Math.max(0, current + event.params.amount))
    this.inputTarget.value = next > 0 ? next : ""
    this.apply()
  }

  navigate(value) {
    const url = new URL(window.location)
    url.searchParams.set(this.paramValue, value)
    window.location.assign(url)
  }
}
